import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { getGlobalProperty } from "./getGlobalProperty";
export var getDocument = function() {
    var _getWindow;
    var _getGlobalProperty;
    return (_getGlobalProperty = getGlobalProperty("document")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow["document"];
};
export var getDocumentOrThrow = function() {
    var document = getDocument();
    if (!document) {
        throw new Error("document not found");
    }
    return document;
};
